<template>
    <div>
        <rkm-modal
            extra-large
            ref="RkmModal"
            title="Novo estorno"
        >
            <rkm-form v-if="model">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidadesDe"
                            disabled
                            label="Unidade de"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeIdDe"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.salasVacinacaoDe"
                            disabled
                            label="Local de atendimento de"
                            show-default-option
                            text-field="nome"
                            v-model="model.salaVacinacaoIdDe"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidadesPara"
                            disabled
                            label="Unidade para"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeIdPara"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.salasVacinacaoPara"
                            disabled
                            label="Local de atendimento para"
                            show-default-option
                            text-field="nome"
                            v-model="model.salaVacinacaoIdPara"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            disabled
                            label="Data"
                            v-model="model.data"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-input
                            disabled
                            label="Código"
                            v-model="model.codigo"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <rkm-table
                            :fields="fields"
                            :items="model.vacinas"
                        >
                            <template v-slot:cell(selecionado)="row">
                                <rkm-form-checkbox
                                    :disabled="row.item.disabled"
                                    v-model="row.item.checked"
                                />
                            </template>

                            <template v-slot:cell(quantidadeRecebida)="row">
                                <rkm-form-input
                                    :value="row.item.lotes.reduce((lote, requisicao) => {return lote + parseInt(requisicao.quantidadeRecebida)}, 0)"
                                    class="m-0"
                                    disabled
                                    type="number"
                                >
                                    <rkm-input-group-append slot="append">
                                        <rkm-button
                                            @click="$refs.ModalLote.open(row.item)"
                                            color="primary"
                                            title="Itens recebidos"
                                        >
                                            <rkm-icon icon="search" />
                                        </rkm-button>
                                    </rkm-input-group-append>
                                </rkm-form-input>
                            </template>
                        </rkm-table>
                    </rkm-col>
                </rkm-row>
            </rkm-form>

            <template v-slot:footer="{ cancel }">
                <rkm-button
                    :disabled="!!loading"
                    @click="cancel"
                    color="secondary"
                >
                    Cancelar
                </rkm-button>

                <rkm-button
                    :disabled="!!loading"
                    @click="save"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>
        </rkm-modal>

        <ModalLote
            v-if="model"
            :additionals="additionals"
            :model="model"
            ref="ModalLote"
        />
    </div>
</template>

<script>
// Components.
import ModalLote from './../lote/Modal'

// Enums.
import parametrizacaoDescricaoVacina from '@/enums/imunizacao/parametrizacaoDescricaoVacina'

// Mixins.
import { error, repository, stringCase } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { ModalLote },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        fields() {
            const fields = [{ class: 'col-min', key: 'selecionado', label: '#' },]

            switch (this.additionals.parametrizacao.parametrizacaoDescricaoVacinaId) {
                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaAbreviacao', label: 'Abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA:
                    fields.push({ key: 'vacinaSigla', label: 'Sigla da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaNome', label: 'Sigla e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA:
                    fields.push({ key: 'vacinaSiglaAbreviacao', label: 'Sigla e abreviação da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaAbreviacaoNome', label: 'Abreviação e nome da vacina' })
                    break;

                case this.enums.parametrizacaoDescricaoVacina.SIGLA_DESCRICAO_ABREVIADA_DESCRICAO:
                    fields.push({ key: 'vacinaSiglaAbreviacaoNome', label: 'Sigla, abreviação e nome da vacina' })
                    break;

                default:
                    fields.push({ key: 'vacinaNome', label: 'Nome da vacina' })
                    break;
            }

            fields.push(
                { key: 'quantidade', label: 'Quantidade requisitada' },
                { key: 'quantidadeRecebida', label: 'Quantidade recebida' }
            )

            return fields
        },
    },
    created() {
        this.repositories = {
            requisicao: this.getConectaSusRepository('imunizacao.requisicao'),
        }
    },
    data: () => ({
        additionals: null,
        enums: { parametrizacaoDescricaoVacina },
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.load(item)
            this.$refs.RkmModal.show()
        },
        load(item) {
            this.additionals = null
            this.form = null
            this.model = null

            const request = {
                tipoMovimentacao: 'estorno',
                requisicaoId: item.id,
            }

            this.setLoading()

            this.repositories.requisicao.create(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        save() {
            const vacinas = this.model.vacinas.filter(vacina => vacina.checked === true)

            if (vacinas.length === 0) {
                this.showValidationNotification('Obrigatório selecionar pelo menos uma vacina.')
                return
            }

            const request = {
                tipoMovimentacao: 'estorno',
                id: this.model.id,
                statusId: this.model.statusId,
                salaVacinacaoIdDe: this.model.salaVacinacaoIdDe,
                salaVacinacaoIdPara: this.model.salaVacinacaoIdPara,
                vacinas: vacinas.map(vacina => vacina.id),
            }

            this.setLoading()

            this.repositories.requisicao.store(this.camelObjectKeysToSnakeRecursive(request))
                .then(() => {
                    this.showSaveNotification()
                    this.handleExit()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExit() {
            this.$emit('save')
            this.$refs.RkmModal.hide()
        },
    },
    mixins: [ error, repository, stringCase ],
}
</script>